import * as yup from "yup";

const VoucherCodeSchema = yup.object().shape({
  code: yup
    .string()
    .required("Kodi eshte i detyrueshem.")
    .min(3, "Minimumi 3 karaktere."),
  rewardType: yup
    .number()
    .oneOf([1, 2], "Zgjidh llojin e shperblimit.")
    .required("Lloji i shperblimit eshte i detyrueshem."),
  usageMode: yup
    .number()
    .oneOf([1, 2], "Zgjidh menyren e perdorimit.")
    .required("Menyra e perdorimit eshte e detyrueshme."),
  packageTemplateId: yup
    .number()
    .nullable()
    .transform((value, original) => (original === "" ? null : value))
    .when("rewardType", {
      is: 1,
      then: (schema) =>
        schema
          .required("Package Template ID eshte i detyrueshem per eSIM.")
          .typeError("Package Template ID duhet te jete numer.")
    }),
  creditAmount: yup
    .number()
    .nullable()
    .transform((value, original) => (original === "" ? null : value))
    .when("rewardType", {
      is: 2,
      then: (schema) =>
        schema
          .required("Shuma e kreditit eshte e detyrueshme per Credits.")
          .typeError("Shuma duhet te jete numer.")
          .min(0.01, "Shuma duhet te jete me e madhe se 0.")
    }),
  lockedToEmail: yup
    .string()
    .nullable()
    .when("usageMode", {
      is: 2,
      then: (schema) =>
        schema
          .required("Email eshte i detyrueshem per EmailLocked.")
          .email("Email duhet te jete i vlefshëm.")
    }),
  expiresAtUtc: yup.string().nullable(),
  isActive: yup.boolean()
});

export default VoucherCodeSchema;
